<template>
    <Sheet class="container">
        <h1 class="success">登記成功</h1>
        <div>
            請按此
            <el-button
                    type="success"
                    style="margin: 0 2px;"
                    @click="toBooking"
            >
                繼續借用
            </el-button>
        </div>
    </Sheet>
</template>

<script>
    export default {
        name: 'BookingResult',
        methods:{
            toBooking(){
                this.$router.push({name:'booking/normal'});
            }
        },
        created() {
            const {success} = this.$route.params;
            if(!success){
                this.$router.push({name:'noFound'});
            }
        }
    }
</script>

<style scoped>
    .container{
        text-align: center;
    }
    .container .success{
        font-size: 4rem;
        font-weight: bolder;
        color: green;
    }

</style>